import { useEffect, useRef, useState } from "react"
import Annonce from "../../components/nouvelleAnnonce/SaisieAnnonce"
import TypeAnnonce from "../../components/nouvelleAnnonce/TypeAnnonce"
import ButtonCustomIcon from "../../utils/custom-button-icon"
import { faArrowLeft, faArrowRight } from "@fortawesome/free-solid-svg-icons"
import ButtonCustomIcon2 from "../../utils/custom-button-icon2"
import SupportPresse from "../../components/nouvelleAnnonce/SupportPresse"
import Validation from "../../components/Validation"
import { type TabStypeItem, tabStypeItemDefaultValue } from "../../models/typeAnnonce"
import type { PressData } from "../../models/listpress"
import AnnonceAssiste from "../../components/nouvelleAnnonce/SaisieAnnonceAssiste"
import Payment from "./Payment"
import { Elements } from "@stripe/react-stripe-js"
import { loadStripe } from "@stripe/stripe-js"
import { societeConcerne } from "../../constant/legalFormOptions"
import Swal from "sweetalert2"
import useAppContext from "../../hooks/useAppContext"
import type { AppContextType } from "../../context/AppContext"
import { createPaymentIntent } from "../../services/Payment_service"
import { saveDraft } from "../../services/Draft_service"
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom"
import { toast, ToastContainer } from "react-toastify"
import { getAnnonceTemp } from "../../services/Annonce_service"
import { getUserDetails } from "../../services/User_service"
import DraftSaveButton from "./draft/DraftSaveButton"
import { useDraftManager } from "../../hooks/useDraftManager"
import { formatObjectText } from "../../utils/functions/formatObjectText"
import { trackMenuClick } from "../../services/menuClick_service";

// const stripePromise = loadStripe(
//   "pk_test_51R8mC2FPohEfWwuOBklqfjkcdxAWGGQPqaJIt6hlWL4t78bvbUjexkqT9Jcb6gyOxYogfZYWUWCep7kFhaGbCjZQ00qwdUIQFm"
// )

const stripePromise = loadStripe(
  "pk_live_51NnIemFWD8X8BCJFhd9fdL9kvNNzcqHuIjkF4cruDMhIYRXO6921VOVZAIlrps9nUuyZEefLVQcORUWFhyU9LV9s00aOkbwcLa"
);

const NouvelleAnnonce = () => {
  const {
    clearContext,
    lastTab,
    draftFormData,
    selectedType,
    setSelectedType,
    activeIndex,
    setActiveIndex,
    checkedIndex,
    setCheckedIndex,
    entete, setEntete,
    floid, setFloid,
    logoLibelle,
    choix,
    denomination, setDenomination,
    texteAnnonce, setTexteAnnonce,
    setLegalForm,
    setPressSupportPostalCode,
    setPressSupportCity,
    authenticatedUser, setAuthenticatedUser
  } = useAppContext() as AppContextType

  const { pushDraftContent } = useDraftManager()

  const [isSubmitted, setIsSubmitted] = useState<boolean>(false)
  const [isAnnonceValid, setIsAnnonceValid] = useState<boolean>(false)
  const [selectedSupport, setSelectedSupport] = useState<PressData | null>(null)
  const [societeSelected, setSocieteSelected] = useState<string>("")
  const [pressData, setPressData] = useState<PressData[]>([])
  const [postalCodeProp, setPostalCodeProp] = useState<string | undefined>(undefined)

  const [nJustif, setNJustif] = useState<number>(1)
  const [annonceur, setAnnonceur] = useState<string>("")
  const [reference, setReference] = useState<string>("")
  const [Parrution, setParrution] = useState<string>("")

  const [payements, setPayment] = useState<string>("")
  const [pointsDiscountApplied, setPointsDiscountApplied] = useState(0)
  const [avoirsDiscountApplied, setAvoirsDiscountApplied] = useState(0)

  // Ajout pour Stripe
  const [dynamicClientSecret, setDynamicClientSecret] = useState("")
  const [dynamicPaymentRef, setDynamicPaymentRef] = useState("")
  const [dynamicPaymentAmount, setDynamicPaymentAmount] = useState(0)
  const [showStripeForm, setShowStripeForm] = useState(false)

  const [localTxtAnnonce, setLocalTxtAnnonce] = useState<string>("")
  // const [authenticatedUser, setAuthenticatedUser] = useState<UserModel | null>(null)

  const [showModal, setShowModal] = useState(false)
  const [searchParams] = useSearchParams()
  const hasVerified = useRef(false)
  const navigate = useNavigate()
  const location = useLocation()
  const { type } = useParams<{ type: string }>()

  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [fromDraft, setFromDraft] = useState<boolean>(false)
  const [draftId, setDraftId] = useState<string | null>(null)
  const [isLoadedFromDraft, setIsLoadedFromDraft] = useState<boolean>(false);

  const [hasFreeAnnouncement, setHasFreeAnnouncement] = useState<boolean>(false)
  const [checkingFreeAnnouncement, setCheckingFreeAnnouncement] = useState<boolean>(true)

  const [discountDetails, setDiscountDetails] = useState({
    discountPercentageAmount: 0,
    pointsDiscountAmount: 0,
    creditNoteDiscountAmount: 0,
    totalDiscountAmount: 0,
    discountClaimed: false,
    discountSentToClient: false
  });

  // États pour gérer la sauvegarde automatique
  const [isFromKlarnaReturn, setIsFromKlarnaReturn] = useState(false);
  const [initialLoadComplete, setInitialLoadComplete] = useState(false);
  const hasAutoSavedRef = useRef(false);
  // const [isRestoringFromKlarna, setIsRestoringFromKlarna] = useState(false);


  // ==========================================
  // USEEFFECT 1 : Type d'annonce depuis URL
  // ==========================================
  useEffect(() => {
    if (type && !selectedType) {
      const announcementType = type.charAt(0).toUpperCase() + type.slice(1)
      setSelectedType({
        nType: 0,
        sSType: announcementType,
        nSType: 0,
      })
      console.log("✅ Type d'annonce défini depuis URL:", announcementType)
    }
  }, [type, selectedType, setSelectedType])

  // ==========================================
  // USEEFFECT 2 : Détection brouillon depuis navigation
  // ==========================================
  useEffect(() => {
    if (location.state) {
      const { fromDraft: fromDraftState, draftId: draftIdState } = location.state as {
        fromDraft?: boolean
        draftId?: string
      }
      if (fromDraftState) {
        setFromDraft(true)
        setIsLoadedFromDraft(true)
        if (draftIdState) {
          setDraftId(draftIdState)
        }
        console.log("📂 Brouillon chargé depuis navigation - sauvegarde automatique désactivée");
      }
    }
  }, [location.state])

  // ==========================================
  // USEEFFECT 2B : Préremplissage depuis lien externe
  // ==========================================
  useEffect(() => {
  let state = location.state as {
    fromExternal?: boolean
    externalStep?: number
    externalMode?: number
    externalType?: TabStypeItem
  } | null

  if (!state?.fromExternal) {
    const stored = sessionStorage.getItem("externalAnnonceParams")
    if (stored) {
      sessionStorage.removeItem("externalAnnonceParams")
      const parsed = JSON.parse(stored)
      state = {
        fromExternal: true,
        externalStep: parsed.externalStep,
        externalMode: parsed.externalMode,
        externalType: parsed.externalType,
      }
    }
  }

  if (!state?.fromExternal) return

  if (state.externalMode === 0 || state.externalMode === 1) {
    setCheckedIndex(state.externalMode)
  }

  if (state.externalType?.sSType) {
    setSelectedType({
      nType:  Number(state.externalType.nType)  || 0,
      nSType: Number(state.externalType.nSType) || 0,
      sSType: state.externalType.sSType,
    })
  }

  if (state.externalStep === 1 || state.externalStep === 2) {
    setActiveIndex(state.externalStep)
  }

  navigate(`${location.pathname}${location.search}`, { replace: true, state: null })
}, [
  location.pathname,
  location.search,
  location.state,
  navigate,
  setActiveIndex,
  setCheckedIndex,
  setSelectedType,
])

  // ==========================================
  // USEEFFECT 3 : Vérification privilèges utilisateur
  // ==========================================
  useEffect(() => {
    const checkUserPrivileges = async () => {
      setCheckingFreeAnnouncement(true)
      try {
        const userData = await getUserDetails()
        if (userData) {
          setAuthenticatedUser(userData)
          if ("hasFreeAnnouncement" in userData) {
            setHasFreeAnnouncement(!!userData.hasFreeAnnouncement)
          }
        }
      } catch (error) {
        console.error("Erreur lors de la vérification des privilèges utilisateur:", error)
      } finally {
        setCheckingFreeAnnouncement(false)
      }
    }
    checkUserPrivileges()
  }, [])

// ==========================================
// USEEFFECT 4 : Gestion retours Stripe/Klarna
// ==========================================
useEffect(() => {
  const paymentIntent = searchParams.get("payment_intent")
  const redirectStatus = searchParams.get("redirect_status")
  
  if (paymentIntent && redirectStatus === "succeeded" && !hasVerified.current) {
    // CAS 1 : Paiement réussi → Redirection vers gestion annonces
    navigate(`/home/gestion-annonces${location.search}`, { replace: true })
    
  } else if (paymentIntent && (redirectStatus === "failed" || redirectStatus === "canceled") && !hasVerified.current) {
    // CAS 2 : Retour Klarna (échec/annulation) → Restaurer à l'étape 2 (Support Presse)
    console.log("🔄 Détection retour Klarna - Restauration des données...");
    
    // IMPORTANT : Marquer qu'on est en retour Klarna
    setIsFromKlarnaReturn(true)
    setIsLoadedFromDraft(true) // Désactiver sauvegarde auto
    
    // Récupérer et restaurer les données de l'annonce temporaire
    getAnnonceTemp(paymentIntent)
      .then((data) => {
        if (data?.data) {
          console.log("📥 Données récupérées depuis annonce temporaire:", data.data)
          
          // 1. Type d'annonce EN PREMIER
          if (data.data.type_annonce) {
            setSelectedType({
              nType: Number(data.data.type) || 0,
              sSType: data.data.type_annonce,
              nSType: Number(data.data.stype) || 0,
            })
            console.log("✅ Type annonce restauré:", data.data.type_annonce)
          }
          
          // 2. Code postal et ville IMMÉDIATEMENT
          if (data.data.postal_code) {
            setPostalCodeProp(data.data.postal_code)
            setPressSupportPostalCode(data.data.postal_code)
            console.log("✅ Code postal restauré:", data.data.postal_code)
          }
          
          if (data.data.city) {
            setPressSupportCity(data.data.city)
            console.log("✅ Ville restaurée:", data.data.city)
          }
          
          // 3. Texte de l'annonce
          if (data.data.text_annonce) {
            setLocalTxtAnnonce(data.data.text_annonce)
            setTexteAnnonce(data.data.text_annonce)
            console.log("✅ Texte annonce restauré")
          }
          
          // 4. Autres informations
          if (data.data.entete) {
            setEntete(data.data.entete)
            console.log("✅ En-tête restauré")
          }
          
          if (data.data.floid) {
            setFloid(data.data.floid)
            console.log("✅ Logo restauré")
          }
          
          if (data.data.denomination) {
            setDenomination(data.data.denomination)
            console.log("✅ Dénomination restaurée")
          }
          
          if (data.data.legal_form) {
            setLegalForm(data.data.legal_form)
            console.log("✅ Forme juridique restaurée")
          }
          
          // 5. Support sélectionné - ATTENDEZ QUE LE COMPOSANT SOIT MONTÉ
          if (data.data.selected_support) {
            // Stocker temporairement le support pour le restaurer après
            setTimeout(() => {
              console.log("✅ Restauration support après montage:", data.data.selected_support)
              setSelectedSupport(data.data.selected_support)
            }, 1500) // Augmenter le délai à 1.5s
          }
          
          // 6. Positionner à l'étape 2 APRÈS un court délai
          setTimeout(() => {
            setActiveIndex(2)
            console.log("✅ Navigation vers étape 2 (Support Presse)")
          }, 500) // Petit délai pour laisser les states se mettre à jour
          
        }
      })
      .catch((error) => {
        console.error("❌ Erreur lors de la récupération de l'annonce temporaire:", error)
        toast.error("Impossible de restaurer les données de l'annonce")
        setActiveIndex(0)
      })
  }
  
  hasVerified.current = true
}, [searchParams, navigate, location.search, setActiveIndex, setPressSupportPostalCode, setPressSupportCity])

  // ==========================================
  // USEEFFECT 5 : Marquer le chargement initial comme terminé
  // ==========================================
  useEffect(() => {
    if (!initialLoadComplete && selectedType && authenticatedUser) {
      // Attendre un peu pour s'assurer que toutes les données sont chargées
      const timer = setTimeout(() => {
        setInitialLoadComplete(true);
        console.log("✅ Chargement initial terminé - sauvegarde automatique peut être activée");
      }, 2000);

      return () => clearTimeout(timer);
    }
  }, [selectedType, authenticatedUser, initialLoadComplete]);

  // ==========================================
  // USEEFFECT 6 : SAUVEGARDE AUTOMATIQUE
  // ==========================================
  useEffect(() => {
    const triggerAutoSave = async () => {
      // Conditions pour déclencher la sauvegarde automatique
      const shouldAutoSave =
        activeIndex === 2 &&
        authenticatedUser?.email &&
        !isFromKlarnaReturn && // Pas de sauvegarde si retour Klarna
        initialLoadComplete &&
        !hasAutoSavedRef.current &&
        selectedType?.sSType &&
        !fromDraft && // Pas de sauvegarde si brouillon chargé depuis navigation
        !isLoadedFromDraft; // Pas de sauvegarde si brouillon chargé (général)

      if (shouldAutoSave) {
        try {
          console.log("💾 Sauvegarde automatique déclenchée...");

          await saveDraft({
            formData: draftFormData,
            activeIndex,
            activeTab: lastTab,
            email: authenticatedUser.email,
            entete,
            floId: floid,
            typeEntete: choix,
            announcementType: selectedType.sSType.toString(),
            isAutoSave: true,
          });

          hasAutoSavedRef.current = true;
          console.log("✅ Sauvegarde automatique réussie");

        } catch (error) {
          console.error("❌ Échec de la sauvegarde automatique", error);
        }
      } else if (activeIndex === 2) {
        // Debug pour comprendre pourquoi la sauvegarde n'est pas déclenchée
        console.log("🔍 Sauvegarde automatique bloquée:", {
          fromDraft,
          isLoadedFromDraft,
          isFromKlarnaReturn,
          hasAutoSaved: hasAutoSavedRef.current,
          initialLoadComplete,
          hasEmail: !!authenticatedUser?.email,
          hasSelectedType: !!selectedType?.sSType
        });
      }
    };

    triggerAutoSave();
  }, [
    activeIndex,
    authenticatedUser,
    draftFormData,
    isFromKlarnaReturn,
    initialLoadComplete,
    selectedType,
    fromDraft,
    isLoadedFromDraft,
    lastTab,
    entete,
    floid,
    choix
  ]);

  useEffect(() => {
  pushDraftContent({ checkedIndex: checkedIndex })
}, [checkedIndex])

  // ==========================================
  // HANDLERS
  // ==========================================
  const handleCheckboxChange = (index: number) => {
  trackMenuClick(
    index === 0 ? 'annonce-mode-libre' : 'annonce-mode-assiste',
    index === 0 ? 'Mode rédaction libre' : 'Mode rédaction assisté'
  );
  setCheckedIndex(index);
  pushDraftContent({ checkedIndex: index });
  clearContext();
  setLegalForm("");
  setLocalTxtAnnonce("");
  setDenomination("");
};

  const handleTypeSelection = (selectedType: TabStypeItem) => {
    trackMenuClick(
    `annonce-type-${selectedType.sSType?.toString().toLowerCase().replace(/\s+/g, '-')}`,
    `Choix type annonce : ${selectedType.sSType}`
  );
    clearContext();
    setSelectedType(selectedType);
    setLegalForm("");
    setLocalTxtAnnonce("");
    setDenomination("");
    handleNext();
  }

  const handleClick = (index: number) => {
    if (index < activeIndex) {
      setActiveIndex(index)
    }
  }

  const updateTxtAnnonce = (newTxt: string) => {
    setLocalTxtAnnonce(newTxt)
    setTexteAnnonce(newTxt)
  }

  const updateFloid = (newTxt: string) => {
    setFloid(newTxt)
  }


  const updateEntete = (newTxt: string) => {
    setEntete(newTxt)
  }

  const updateAnnonceur = (newTxt: string) => {
    setAnnonceur(newTxt)
  }

  const updateReference = (newTxt: string) => {
    setReference(newTxt)
  }

  const udpateDenomination = (newTxt: string) => {
    setDenomination(newTxt)
    pushDraftContent({ denomination: newTxt })
  }

  const updateActiveIndex = (index: number) => {
    setActiveIndex(index)
  }

  const handleNext = () => {
    if (activeIndex === 1) {
      const formatted = formatObjectText(localTxtAnnonce);
      if (formatted !== localTxtAnnonce) setLocalTxtAnnonce(formatted);
      if (!isAnnonceValid || !formatted) {
        setIsSubmitted(true);
        return;
      }
    } else if (activeIndex === 2 && !selectedSupport) {
      Swal.fire({
        title: "Support de presse!",
        text: "Veuillez selectionner un support!",
        icon: "warning",
      });
      return;
    }
    setTimeout(() => setActiveIndex((prevIndex) => prevIndex + 1), 0);
  };

  const updateDateParution = (newDate: Date) => {
    setParrution(newDate.toISOString())
  }

  const handleDynamicPaymentIntent = async (
    amount: number,
    description = "",
    discountDetailsParam?: {
      discountPercentageAmount: number;
      pointsDiscountAmount: number;
      creditNoteDiscountAmount: number;
      totalDiscountAmount: number;
      discountClaimed: boolean;
      discountSentToClient: boolean
    }
  ) => {
    try {
      trackMenuClick('annonce-page-paiement', 'Page de paiement');
      console.log("[DEBUG] handleDynamicPaymentIntent appelée avec:", {
        amount,
        description,
        discountDetails: discountDetailsParam
      });

      if (discountDetailsParam) {
        setDiscountDetails(discountDetailsParam);
      }

      const response = await createPaymentIntent(amount, description);
      console.log("[DEBUG] Réponse createPaymentIntent:", response);

      setDynamicClientSecret(response.clientSecret);
      setDynamicPaymentRef(response.paymentRef);
      setDynamicPaymentAmount(amount);
      setShowStripeForm(true);

      console.log("[DEBUG] Avant setActiveIndex(4), activeIndex actuel:", activeIndex);
      setActiveIndex(4);
      console.log("[DEBUG] Après setActiveIndex(4)");

    } catch (error) {
      console.error("[ERROR] handleDynamicPaymentIntent:", error);
      toast.error("Erreur lors de la création du paiement : " + (error as Error).message);
    }
  };


  const resetPressSupport = () => setSelectedSupport(null)

  const handlePrevious = () => {
    setActiveIndex((prevIndex) => prevIndex - 1)
  }

  const handleAnnonceValidation = (isValid: boolean) => {
    setIsAnnonceValid(isValid)
  }


  const handleSaveDraft = async (email: string) => {
    trackMenuClick('annonce-save-draft', 'Sauvegarder dans mes brouillons');
  setIsLoading(true);
  setIsLoading(true);
  try {
    if (!selectedType || !selectedType.sSType) {
      toast.error("Veuillez sélectionner un type d'annonce avant de sauvegarder");
      setIsLoading(false);
      return;
    }
    
    const response = await saveDraft({
      formData: draftFormData,
      activeIndex,
      activeTab: lastTab,
      email: email,
      entete,
      floId: floid,
      typeEntete: choix,
      announcementType: selectedType.sSType.toString(),
    });
    
    if (response.success) {
      // ✅ Vérifier si l'utilisateur était anonyme
      const wasAnonymousUser = localStorage.getItem("wasAnonymous") === "true";
      
      if (wasAnonymousUser) {
        // Nettoyer le flag
        localStorage.removeItem("wasAnonymous");
        
        console.log("🔄 Redirection avec rechargement complet...");
        
        // Utiliser window.location.href pour forcer le rechargement
        window.location.href = "/home/draft";
      } else {
        // Navigation normale pour les utilisateurs déjà connectés
        navigate("/home/draft");
      }
    } else {
      toast.error(response.message || "Erreur lors de la sauvegarde");
    }
  } catch (error) {
    console.error("❌ Erreur lors de la sauvegarde:", error);
    toast.error("Une erreur est survenue lors de la sauvegarde");
  } finally {
    setIsLoading(false);
  }
};

  // ==========================================
  // RENDER
  // ==========================================

  // Afficher un loader pendant la restauration Klarna
  // if (isRestoringFromKlarna) {
  //   return (
  //     <div className="top">
  //       <ToastContainer />
  //       <div className="loading-overlay">
  //         <div className="spinner-container">
  //           <div className="spinner"></div>
  //           <p>Restauration de votre annonce en cours...</p>
  //           <p style={{ fontSize: '14px', marginTop: '10px', color: '#6c757d' }}>
  //             Veuillez patienter, ne fermez pas cette page.
  //           </p>
  //         </div>
  //       </div>
  //     </div>
  //   )
  // }

  return (
    <div className="top">
      <ToastContainer />
      {isLoading && (
        <div className="loading-overlay">
          <div className="spinner-container">
            <div className="spinner"></div>
            <p>Traitement en cours...</p>
          </div>
        </div>
      )}

      {fromDraft && draftId && (
        <div className="draft-info-banner">
          <p>Vous travaillez sur un brouillon (ID: {draftId})</p>
        </div>
      )}

      {/* {isFromKlarnaReturn && (
        <div className="alert alert-warning mx-3 mt-2" style={{
          backgroundColor: '#fff3cd',
          borderColor: '#ffc107',
          color: '#856404',
          padding: '12px 20px',
          borderRadius: '4px',
          marginBottom: '15px'
        }}>
          <strong>⚠️ Paiement non finalisé</strong> - Vos données ont été restaurées. Vous pouvez continuer votre annonce.
        </div>
      )} */}

      {activeIndex === 0 ? (
        <h6 className="mx-3 bg-col mt-2">SAISIR UNE ANNONCE LEGALE</h6>
      ) : (
        <h6 className="mx-3 bg-col mt-2">ANNONCE LEGALE : {selectedType?.sSType}</h6>
      )}

      {hasFreeAnnouncement && !checkingFreeAnnouncement && (
        <div className="alert alert-info mx-3 mt-2">
          <strong>Information :</strong> Vous bénéficiez du privilège d'annonce gratuite. Votre annonce sera créée sans paiement.
        </div>
      )}

      <nav className="navbar navbar-expand-lg d-none d-md-block">
        <div className="container-fluid">
          <div className={`navbar-brand d-flex ${activeIndex === 0 ? "active" : ""}`} onClick={() => handleClick(0)}>
            <span className={activeIndex === 0 ? "number-circle-on" : "number-circle"}>
              <span className="colorNumber">1</span>
            </span>
            <p className={activeIndex === 0 ? "txt-index-on" : "txt-index-off"}>Type d'annonce</p>
          </div>
          <div className={`navbar-brand d-flex ${activeIndex === 1 ? "active" : ""}`} onClick={() => handleClick(1)}>
            <span className={activeIndex === 1 ? "number-circle-on" : "number-circle"}>
              <span className="colorNumber">2</span>
            </span>
            <p className={activeIndex === 1 ? "txt-index-on" : "txt-index-off"}>Saisie Annonce</p>
          </div>
          <div className={`navbar-brand d-flex ${activeIndex === 2 ? "active" : ""}`} onClick={() => handleClick(2)}>
            <span className={activeIndex === 2 ? "number-circle-on" : "number-circle"}>
              <span className="colorNumber">3</span>
            </span>
            <p className={activeIndex === 2 ? "txt-index-on" : "txt-index-off"}>Support Presse</p>
          </div>
          <div className={`navbar-brand d-flex ${activeIndex === 3 ? "active" : ""}`} onClick={() => handleClick(3)}>
            <span className={activeIndex === 3 ? "number-circle-on" : "number-circle"}>
              <span className="colorNumber">4</span>
            </span>
            <p className={activeIndex === 3 ? "txt-index-on" : "txt-index-off"}>Validation</p>
          </div>
          <div className={`navbar-brand d-flex ${activeIndex === 4 ? "active" : ""}`} onClick={() => handleClick(4)}>
            <span className={activeIndex === 4 ? "number-circle-on" : "number-circle"}>
              <span className="colorNumber">5</span>
            </span>
            <p className={activeIndex === 4 ? "txt-index-on" : "txt-index-off"}>Paiement</p>
          </div>
          <div className="collapse navbar-collapse" id="navbarNav"></div>
        </div>
      </nav>

      <div className="content">
        {activeIndex === 0 && (
          <TypeAnnonce
            setIsSubmitted={setIsSubmitted}
            onClick={handleTypeSelection}
            onCheckboxChange={handleCheckboxChange}
            checkedIndex={checkedIndex}
          />
        )}

        {activeIndex === 1 &&
          (checkedIndex === 0 ? (
            <Annonce
              onValidate={handleAnnonceValidation}
              isSubmitted={isSubmitted}
              updateTxtAnnonce={updateTxtAnnonce}
              txtAnnonce={texteAnnonce}
              updateEntete={updateEntete}
              entete={entete}
              floid={floid}
              updateFloid={updateFloid}
              reference={reference}
              updateReference={updateReference}
              updateAnnonceur={updateAnnonceur}
              annonceur={annonceur}
              updateDenomination={udpateDenomination}
              societyType={
                selectedType?.sSType == ""
                  ? ""
                  : societeConcerne[`${selectedType?.sSType.toString()}`]
                    ? societeConcerne[`${selectedType?.sSType.toString()}`].societe
                    : ""
              }
              societeSelected={societeSelected}
              updatesocieteSelected={setSocieteSelected}
              updateLegalForm={setLegalForm}
            />
          ) : checkedIndex === 1 ? (
            <AnnonceAssiste
              selectedType={selectedType?.sSType.toString()}
              floid={floid}
              updateFloid={updateFloid}
              onValidate={handleAnnonceValidation}
              updateTxtAnnonce={updateTxtAnnonce}
              txtAnnonce={texteAnnonce}
              denomination={denomination}
              updateDenomination={udpateDenomination}
              activeIndex={activeIndex}
              updateActiveIndex={updateActiveIndex}
              entete={entete}
              updatesocieteSelected={setSocieteSelected}
              societyType={
                selectedType?.sSType == ""
                  ? ""
                  : societeConcerne[`${selectedType?.sSType.toString()}`]
                    ? societeConcerne[`${selectedType?.sSType.toString()}`].societe
                    : ""
              }
              updateEntete={updateEntete}
            />
          ) : null)}

        {activeIndex === 2 && (
          <SupportPresse
            selectedSupport={selectedSupport}
            selectedType={selectedType}
            onSupportSelect={setSelectedSupport}
            nJustif={nJustif}
            updateTxtAnnonce={updateTxtAnnonce}
            txtAnnonce={localTxtAnnonce}
            pressData={pressData}
            setPressData={setPressData}
            entete={entete}
            floid={floid}
            logoLibelle={logoLibelle}
            postalCodeProp={postalCodeProp}
          />
        )}

        {activeIndex === 3 && (
          <Validation
            selectedSupport={selectedSupport}
            updateTxtAnnonce={updateTxtAnnonce}
            txtAnnonce={localTxtAnnonce}
            denomination={denomination}
            entete={entete}
            floid={floid}
            nJustif={nJustif}
            updateAnnonceur={updateAnnonceur}
            annonceur={annonceur}
            updateReference={updateReference}
            reference={reference}
            dateParution={new Date(Parrution)}
            updateDateParution={updateDateParution}
            tv_intra={0}
            updateFloid={updateFloid}
            activeIndex={activeIndex}
            setActiveIndex={setActiveIndex}
            type_annonce={selectedType}
            resetPressSupport={resetPressSupport}
            paymentRef={dynamicPaymentRef}
            pointsDiscountApplied={pointsDiscountApplied}
            setPointsDiscountApplied={setPointsDiscountApplied}
            avoirsDiscountApplied={avoirsDiscountApplied}
            setAvoirsDiscountApplied={setAvoirsDiscountApplied}
            onRequestPaymentIntent={handleDynamicPaymentIntent}
            discountDetails={discountDetails}
            setDiscountDetails={setDiscountDetails}
          />
        )}

        {activeIndex === 4 && showStripeForm && dynamicClientSecret !== "" && (
          <Elements options={{ clientSecret: dynamicClientSecret, locale: "fr" }} stripe={stripePromise}>
            <Payment
              selectedSupport={selectedSupport}
              updateTxtAnnonce={updateTxtAnnonce}
              txtAnnonce={localTxtAnnonce}
              denomination={denomination}
              entete={entete}
              floid={floid}
              updateAnnonceur={updateAnnonceur}
              annonceur={annonceur}
              updateReference={updateReference}
              reference={reference}
              dateParution={new Date(Parrution)}
              updateDateParution={updateDateParution}
              tv_intra={0}
              updateFloid={updateFloid}
              selectedAnnouncementType={selectedType ?? tabStypeItemDefaultValue}
              resetPressSupport={resetPressSupport}
              paymentRef={dynamicPaymentRef}
              hasFreeAnnouncement={hasFreeAnnouncement}
              pointsDiscountApplied={pointsDiscountApplied}
              avoirsDiscountApplied={avoirsDiscountApplied}
              paymentAmount={dynamicPaymentAmount}
              onBack={() => setActiveIndex(3)}
              discountPercentageAmount={discountDetails.discountPercentageAmount}
              pointsDiscountAmount={discountDetails.pointsDiscountAmount}
              creditNoteDiscountAmount={discountDetails.creditNoteDiscountAmount}
              totalDiscountAmount={discountDetails.totalDiscountAmount}
              discountClaimed={discountDetails.discountClaimed}
              discountSentToClient={discountDetails.discountSentToClient}
            />
          </Elements>
        )}
      </div>

      <div className="d-flex justify-content-center mb-3 mt-5">
        {activeIndex !== 0 && activeIndex !== 4 && activeIndex !== 3 && !(activeIndex === 1 && checkedIndex === 1) && (
          <ButtonCustomIcon title="Précédent" icon={faArrowLeft} color="#F4A261" onClick={handlePrevious} />
        )}
        {activeIndex !== 0 && activeIndex !== 1 && activeIndex !== 2 && activeIndex === 3 && checkedIndex !== 1 && (
          <ButtonCustomIcon title="Revenir en arrière" icon={faArrowLeft} color="#F4A261" onClick={handlePrevious} />
        )}

        {activeIndex !== 0 && activeIndex !== 3 && activeIndex !== 4 && !(activeIndex === 1 && checkedIndex === 1) && (
          <ButtonCustomIcon2 title="Suivant" icon={faArrowRight} color="#F4A261" onClick={handleNext} />
        )}
      </div>

      {activeIndex === 1 && <DraftSaveButton onSaveDraft={handleSaveDraft} defaultEmail={authenticatedUser?.email} />}
    </div>
  )
}

export default NouvelleAnnonce
